import { render, staticRenderFns } from "./SupInvoiceadd.vue?vue&type=template&id=22b879c7&scoped=true"
import script from "./SupInvoiceadd.vue?vue&type=script&lang=js"
export * from "./SupInvoiceadd.vue?vue&type=script&lang=js"
import style0 from "./SupInvoiceadd.vue?vue&type=style&index=0&id=22b879c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b879c7",
  null
  
)

export default component.exports